import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import PixiGame from "./components/PixiGame";
import AlphabetPuzzleGame from "./pages/AlphabetPuzzleGame";
import BalloonLetterPop from "./pages/BalloonAplbhabetPopUp";
import CategoryPage from './pages/CategoryPage.js';
import NumberRainGame from "./pages/NumberRainGame.js";
import AnimalGame from "./pages/AnimalGame.js";

// function Layout() {
//   const location = useLocation();
//   const hideNavbarRoutes = ["/", "/login", "/signup"]; // Add routes where navbar should be hidden
//   return (
//     <>
//       {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
//       <div className="container mt-4">
//         <Routes>
//           <Route path="/" element={<Login />} />
//           <Route path="/category/:categoryId" element={<CategoryPage />} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/signup" element={<Signup />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/pixi-game" element={<PixiGame />} />
//           <Route path="/alphabet-puzzle" element={<AlphabetPuzzleGame />} />
//           <Route path="/balloon-letter-pop" element={<BalloonLetterPop />} />
//         </Routes>
//       </div>
//     </>
//   );
// }


function Layout() {
  const location = useLocation();
  // remove login/signup from hidden navbar list since you won’t use them now
  const hideNavbarRoutes = []; // Navbar always shows now

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <div className="container mt-4">
        <Routes>
          {/* Default route → Dashboard */}
          <Route path="/" element={<Dashboard />} />

          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/pixi-game" element={<PixiGame />} />
          <Route path="/alphabet-puzzle" element={<AlphabetPuzzleGame />} />
          <Route path="/balloon-letter-pop" element={<BalloonLetterPop />} />
          <Route path="/number-popup-game" element={<NumberRainGame />} />
          <Route path="/animal-game" element={<AnimalGame />} />
        </Routes>
      </div>
    </>
  );
}


export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}
